import { Layers } from "lucide-react"
import type { ClientTheme } from "@/app/lib/themes"

interface Props {
  invLoading: boolean
  trCount: number
  theme: ClientTheme
}

export function TownshipEmptyState({ invLoading, trCount, theme }: Props) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-xl border"
      style={{ height: "420px", borderColor: theme.borderColor, backgroundColor: theme.bgSurface }}
    >
      <div
        className="flex items-center justify-center w-14 h-14 rounded-2xl mb-4"
        style={{ backgroundColor: `${theme.brandPrimary}12` }}
      >
        <Layers size={24} style={{ color: theme.brandPrimary }} />
      </div>
      <p
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: "14px",
          fontWeight: 500,
          color: theme.textPrimary,
        }}
      >
        Select a Township-Range to view the section grid
      </p>
      <p
        style={{
          fontFamily: "var(--font-ui)",
          fontSize: "12px",
          color: theme.textDim,
          marginTop: "4px",
        }}
      >
        {invLoading ? "Loading…" : `${trCount} township-range${trCount !== 1 ? "s" : ""} available`}
      </p>
    </div>
  )
}
